import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Temporal } from '@js-temporal/polyfill';
import { db } from 'src/app/db/db';
import { EPostureType } from 'src/app/domain/enums/posture-type';
import { GlobalTask } from 'src/app/domain/global-task';
import { Task } from 'src/app/domain/task';
import { NotificationManager } from '../notification-manager';
import { StringConverter } from '../string-converter';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-task-box',
    templateUrl: './add-task-box.html',
    styleUrls: ['./add-task-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaskBoxDialog implements OnInit {
    public PostureList: string[] = Object.values(EPostureType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getPostureTypeName(x));
    public Model: Task = new Task();
    public GlobalTaskList: GlobalTask[] = [];
    public SelectedGlobalTask?: GlobalTask;
    private processCode!: string;

    Debut: Date = new Date();
    Fin: Date = new Date();

    NewTaskDescription: string = '';
    IsNewTaskDescriptionVisible: boolean = false;

    constructor(
        private snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<TaskBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.Model.StartedOn = Temporal.Now.plainDateTimeISO();
        this.Model.EndedOn = Temporal.Now.plainDateTimeISO();

        if (data) {
            this.processCode = data.processCode;
            // this.Model.StartedOn = data.startingDate;
            this.Debut = new Date(this.Model.StartedOn.year, this.Model.StartedOn.month - 1, this.Model.StartedOn.day, this.Model.StartedOn.hour, this.Model.StartedOn.minute);
        }

    }

    async ngOnInit() {
        this.GlobalTaskList = await db.getGlobalTaskListByProcessMeasureCode(this.processCode);
        this.GlobalTaskList.splice(0, 0, { Description: 'AJOUTER', Position: 666 });
    }



    canSave() {
        return this.SelectedGlobalTask && this.Model.Posture && this.Model.EndedOn && this.Model.StartedOn && this.Model.Posture;
    }

    debutChanged(event: MatDatepickerInputEvent<Date>) {
        this.Model.StartedOn = Temporal.PlainDateTime.from({ year: this.Debut.getFullYear(), day: this.Debut.getDate(), month: this.Debut.getMonth() + 1, hour: this.Debut.getHours(), minute: this.Debut.getMinutes() });
    }

    timeSetDebut(event: string) {
        this.Debut = this.withTime(this.Debut, event);
        this.Model.StartedOn = Temporal.PlainDateTime.from({ year: this.Debut.getFullYear(), day: this.Debut.getDate(), month: this.Debut.getMonth() + 1, hour: this.Debut.getHours(), minute: this.Debut.getMinutes() });
    }


    finChanged(event: MatDatepickerInputEvent<Date>) {
        this.Model.EndedOn = Temporal.PlainDateTime.from({ year: this.Fin.getFullYear(), day: this.Fin.getDate(), month: this.Fin.getMonth() + 1, hour: this.Fin.getHours(), minute: this.Fin.getMinutes() });
    }

    timeSetFin(event: string) {
        this.Fin = this.withTime(this.Fin, event);
        this.Model.EndedOn = Temporal.PlainDateTime.from({ year: this.Fin.getFullYear(), day: this.Fin.getDate(), month: this.Fin.getMonth() + 1, hour: this.Fin.getHours(), minute: this.Fin.getMinutes() });
    }

    formatTime(value: Date): string {
        return `${String(value.getHours()).padStart(2, '0')}:${String(value.getMinutes()).padStart(2, '0')}`;
    }

    private withTime(value: Date, time: string): Date {
        const [hours, minutes] = time.split(':').map(Number);
        const date = new Date(value);
        date.setHours(hours, minutes, 0, 0);
        return date;
    }

    setTask() {
        if (this.SelectedGlobalTask && this.SelectedGlobalTask.Description !== 'AJOUTER') {
            this.Model.Description = this.SelectedGlobalTask.Description;
            this.Model.Position = this.SelectedGlobalTask.Position;
        }
    }

    async addNewTask() {
        if (this.NewTaskDescription === 'AJOUTER') {
            return;
        }
        const newTask = new GlobalTask({ Description: this.NewTaskDescription, Position: Math.max(...this.GlobalTaskList.map(x => x.Position)) + 1 })
        this.GlobalTaskList.push(newTask)
        const success = await db.addGlobalTask(newTask, this.processCode);
        if (success) {
            this.SelectedGlobalTask = newTask;
            this.setTask();
            NotificationManager.handleSuccess('Tâche créée', this.snackBar);
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.Model);
    }
}
